<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<h2 mat-dialog-title i18n>Delete experiment</h2>
<ng-container *ngIf="data.idList.length>0; else noExperiment">
  <mat-dialog-content i18n>
    Are you sure you want to delete the selected {{data.idList.length === 1 ? 'experiment' :
    data.idList.length + ' experiments'}}?
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button [mat-dialog-close]="true" color="primary"
      cdkFocusInitial i18n>Delete</button>
  </mat-dialog-actions>
</ng-container>

<!-- Template for the case with empty experiment -->
<ng-template #noExperiment>
  <mat-dialog-content i18n>No experiment is selected for deletion.</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="primary" i18n>OK</button>
  </mat-dialog-actions>
</ng-template>